var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCovidSterilization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.778 25.778H4.889a1.31 1.31 0 01-1.333-1.334V12a1.31 1.31 0 011.333-1.333h8.889A1.31 1.31 0 0115.11 12v12.444a1.31 1.31 0 01-1.333 1.334z",
    fill: "#EDF2E9"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.889 11.556a.422.422 0 00-.445.444v12.445c0 .264.18.444.445.444h8.889c.264 0 .444-.18.444-.444V12a.422.422 0 00-.444-.444h-8.89zM2.666 12c0-1.246.976-2.222 2.223-2.222h8.889C15.024 9.778 16 10.754 16 12v12.445a2.198 2.198 0 01-2.222 2.222h-8.89a2.198 2.198 0 01-2.221-2.223V12z",
    fill: props.color
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 4.667H8c-.489 0-.889.4-.889.889v5.333h4.445V5.556c0-.49-.4-.89-.89-.89z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.222 5.333c0-.98.798-1.777 1.778-1.777h2.667c.98 0 1.777.798 1.777 1.777v6.223H6.222V5.333zm4.445 0H8v4.445h2.667V5.333z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.889 9.556a.889.889 0 100-1.778.889.889 0 000 1.778zM21.733 8a.889.889 0 100-1.778.889.889 0 000 1.778zM24.889 6.444a.889.889 0 100-1.777.889.889 0 000 1.777zM15.111 8a.889.889 0 100-1.778.889.889 0 000 1.778zM18.178 6.444a.889.889 0 100-1.777.889.889 0 000 1.777zM21.2 4.933a.889.889 0 100-1.778.889.889 0 000 1.778zM24.267 3.378a.889.889 0 100-1.778.889.889 0 000 1.778zM18.178 9.556a.889.889 0 100-1.778.889.889 0 000 1.778zM21.2 11.111a.889.889 0 100-1.778.889.889 0 000 1.778zM24.267 12.667a.889.889 0 100-1.778.889.889 0 000 1.778zM9.128 15.276c.055-.22.374-.22.429 0 .165.683.429 1.509.803 1.884.385.385 1.233.65 1.915.814a.22.22 0 010 .43c-.726.187-1.629.474-1.915.77-.308.31-.594 1.256-.781 1.994-.055.22-.374.22-.43 0-.186-.727-.473-1.674-.792-1.993-.319-.32-1.243-.606-1.97-.782-.22-.055-.22-.375 0-.43.716-.176 1.64-.462 1.97-.793.32-.319.595-1.189.77-1.894zM10.667 8h.889V6.222h-.89c-.488 0-.888.4-.888.89 0 .488.4.888.889.888z",
    fill: props.color
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.289 20.489a6.224 6.224 0 00-10.622 4.4 6.222 6.222 0 1010.622-4.4z",
    fill: "#54822B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.555 28l-2.472-2.473 1.257-1.257 1.215 1.215 3.663-3.662 1.257 1.256-4.92 4.92z",
    fill: "#fff"
  })));
}

export default SvgIconCovidSterilization;